import { render, staticRenderFns } from "./ColdClientModal.vue?vue&type=template&id=b73ae1d4&scoped=true&"
import script from "./ColdClientModal.vue?vue&type=script&lang=js&"
export * from "./ColdClientModal.vue?vue&type=script&lang=js&"
import style0 from "./ColdClientModal.vue?vue&type=style&index=0&id=b73ae1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73ae1d4",
  null
  
)

export default component.exports